import { CalloutBanner, useRebrand } from "@growtherapy/sprout-ui";

import { faVideo } from "@fortawesome/pro-solid-svg-icons";

import { useTranslate } from "@growtherapy/i18n";

export function AVPermissionCallout() {
  const t = useTranslate();
  const isRebrand = useRebrand();

  return (
    <CalloutBanner
      data-testid="av-permission-callout"
      use={isRebrand ? "green" : "lilac"}
      icon={isRebrand ? null : faVideo}
    >
      {t("telehealth-core:introRoom.youMaySeePopUpRequestingAccess")}
    </CalloutBanner>
  );
}
